
import { defineComponent, PropType, reactive, watch, ref, computed, toRefs } from 'vue-demi';
import searchIcon from 'src/assets/images/search-icon.png';

import i18n from '@/i18n';

type ListType = { value: string | number; label: string }[];

export default defineComponent({
  name: 'PopupChosen',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<ListType>,
      default: () => [],
      required: true,
    },
    chosen: {
      type: [String, Number],
      required: true,
    },
  },
  setup(props, { emit }) {
    const handleClose = () => {
      emit('input', false);
    };
    const searchIconPath = searchIcon;
    const state = reactive({
      chosen: '' as string | number,
    });
    const { options } = toRefs(props);
    const searchContent = ref('');
    const optionsBySearch = computed(() =>
      options.value.filter(item =>
        i18n.t(item.label).toString().toLocaleLowerCase().includes(searchContent.value.toLocaleLowerCase()),
      ),
    );
    watch(
      () => props?.chosen,
      () => {
        state.chosen = props.chosen;
      },
    );
    const handleSearch = e => {
      searchContent.value = e;
    };
    const handleClick = (chosen: string | number) => {
      state.chosen = chosen;
      emit('change', chosen);
      handleClose();
    };

    return {
      props,
      handleSearch,
      optionsBySearch,
      searchIconPath,
      handleClick,
      handleClose,
    };
  },
});
